export enum ModalType {
  SaveApplication = 'saveApplication',
  DeleteApplication = 'deleteApplication',
  RejectApplication = 'rejectApplication',
  ApplicationNotes = 'applicationNotes',
  PaymentFailed = 'paymentFailed',
  PRARestoreFailed = 'praRestoreFailed',
  DeleteActivity = 'deleteActivity',
  ResumePraApplication = 'resumePraApplication',
  ClaimCredits = 'claimCredits',
}
